import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useChat01Store, useCommonChatStore } from '~/store';
import Header from '../Header';
import RightMenu from './RightMenu/Chat/RightMenu';

export interface HeaderChatRoomProps {
  type: 'chat' | 'groupChat';
}

export default function HeaderChatRoom({ type }: HeaderChatRoomProps) {
  const navigate = useNavigate();
  const {
    showCharacter,
    setShowCharacter,
    showSubMenu,
    setShowSubMenu,
    setIsReportOpen,
    isWaitingChatRoomInfo,
    resetAll,
  } = useCommonChatStore((state) => ({
    showCharacter: state.showCharacter,
    setShowCharacter: state.setShowCharacter,
    showSubMenu: state.showSubMenu,
    setShowSubMenu: state.setShowSubMenu,
    isWaitingChatRoomInfo: state.isWaitingChatRoomInfo,
    setIsReportOpen: state.setIsReportOpen,
    resetAll: state.resetAll,
  }));

  const { showVideoCallModal, setShowVideoCallModal } = useChat01Store(
    (state) => ({
      showVideoCallModal: state.showVideoCallModal,
      setShowVideoCallModal: state.setShowVideoCallModal,
    }),
  );

  const submenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    return () => {
      resetAll();
    };
  }, []);

  return (
    <Header.Root style={{ padding: '0 4px' }} transparentBg>
      <Header.PrevButton onPrevClick={() => navigate(-1)} />
      <Header.Section>
        {!isWaitingChatRoomInfo && (
          <RightMenu
            type={type}
            showCharacter={showCharacter}
            setShowCharacter={setShowCharacter}
            showSubMenu={showSubMenu}
            setShowSubMenu={setShowSubMenu}
            submenuRef={submenuRef}
            showVideoCallModal={showVideoCallModal}
            setShowVideoCallModal={setShowVideoCallModal}
            setIsReportOpen={setIsReportOpen}
          />
        )}
      </Header.Section>
    </Header.Root>
  );
}
